import Navigation from './Navigation'
import Footer from './Footer'
import React, {useEffect} from "react";
import {initMeteorAnimation} from './meteorAnimation';
import "../../css/frontend/meteorAnimation.css";
import "../../css/frontend/footer.css"
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Layout({children, showAdminNavigation = false}) {
    useEffect(() => {
        // Initialize the meteor animation in the container with id "meteor-animation"
        const animation = initMeteorAnimation();
        return () => {
            if (animation && typeof animation.stop === "function") {
                animation.stop();
            }
        };
    }, []);
    const {t} = useTranslation();
    return (
        <>
            {showAdminNavigation && <Navigation/>}
            {/* Meteor Animation Container */}
            <div id="meteor-animation" className="meteor-background"></div>

            <main className='main-block'>
                <div className='container'>
                    {children}
                </div>
            </main>
            <div className="bottom-block-container">
                {/* --- Core site links --- */}
                <div className="footer-block-top">
                    <nav className="keep-exploring">
                            <span
                                className="keep-exploring-label">{t('Keep Exploring:') || 'Συνέχισε την περιήγηση:'}</span>
                        <NavLink to="/information"
                                 className={({isActive}) =>
                                     'nav-link-menu-item' + (isActive ? ' active' : '')
                                 }>{t("Information")}</NavLink>
                        <NavLink to="/activities"
                                 className={({isActive}) =>
                                     'nav-link-menu-item' + (isActive ? ' active' : '')
                                 }>{t("Activities")}</NavLink>
                        <NavLink to="/projects"
                                 className={({isActive}) =>
                                     'nav-link-menu-item' + (isActive ? ' active' : '')
                                 }>{t("Projects")}</NavLink>
                    </nav>
                </div>
            </div>
            {showAdminNavigation && <Footer/>}
        </>
    )
}
